import { IssueTypeEnum } from '../types';
/**
 * Issue types that are back-office only and cannot be sent to technicians for correction.
 * These types are excluded from the "Suggest Correction" workflow in bulk actions,
 * the detail blade, and the confirm modal.
 */
export const NON_SUGGESTABLE_ISSUE_TYPES = [
    IssueTypeEnum.TimingAudit,
    IssueTypeEnum.UnresolvedPriorDeficiencies,
    IssueTypeEnum.AssetCountChange,
    IssueTypeEnum.RecurringDeficiencies,
    IssueTypeEnum.ProximityCheck,
    IssueTypeEnum.AnalyzeDeficiencyPhotos,
    IssueTypeEnum.SignatureQualityCheck,
    IssueTypeEnum.PumpCurveCheck,
    IssueTypeEnum.DuplicatePhotoDetected
];
export function isNonSuggestableIssueType(issueType) {
    return NON_SUGGESTABLE_ISSUE_TYPES.includes(issueType);
}
